import { Modal } from 'components/common/Modal/Modal';
import s from './Instruction.module.css';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { Button } from 'components/common/Button/Button';
import { useState } from 'react';
import {
  useDeleteUserInstructionMutation,
  useUpdateUserInstructionMutation,
} from 'store/features/user/user-api';
import { useQueryError } from 'lib/hooks/useQueryError';
import { useAppSelector } from 'store/hooks';
import { selectUserInstruction } from 'store/features/user/selectors';
import { ErrorModal } from 'components/common/ErrorModal/ErrorModal';
import { Loader } from 'components/common/Loader/Loader';

export const Instruction = () => {
  const { t } = useTranslation();
  const { closeRouteModal, goBack } =
    useOutletContext<ModalNavigationContext>();

  const userInstruction = useAppSelector(selectUserInstruction);

  const [
    updateUserInstruction,
    {
      isLoading: isUpdatingInstruction,
      isError: isUpdateInstructionError,
      error: updateInstructionError,
    },
  ] = useUpdateUserInstructionMutation();

  const [
    deleteUserInstruction,
    {
      isLoading: isDeletingInstruction,
      isError: isDeleteInstructionError,
      error: deleteInstructionError,
    },
  ] = useDeleteUserInstructionMutation();

  const { showError, errorMessage, closeError } = useQueryError(
    isUpdateInstructionError || isDeleteInstructionError,
    updateInstructionError || deleteInstructionError,
  );

  const [instruction, setInstruction] = useState<string>(userInstruction || '');

  const isDisabled = !instruction.trim() || instruction === userInstruction;

  const handleChangeInstruction = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setInstruction(e.target.value);
  };

  const handleRemoveInstruction = async () => {
    try {
      await deleteUserInstruction().unwrap();
      goBack();
    } catch {}
  };

  const handleApplyInstruction = async () => {
    try {
      await updateUserInstruction(instruction).unwrap();
      goBack();
    } catch {}
  };

  return (
    <Modal
      title={t('profile.personalization.instruction.title')}
      onClose={closeRouteModal}
      onBack={goBack}
    >
      <div className={s['container']}>
        <fieldset className={s['instruction-field']}>
          <legend>{t('profile.personalization.instruction.title')}</legend>

          <textarea
            className={s['instruction-textarea']}
            value={instruction}
            onChange={handleChangeInstruction}
            placeholder={t('profile.personalization.instruction.description')}
          />
        </fieldset>

        <div className={s['buttons']}>
          <Button className={s['remove-btn']} onClick={handleRemoveInstruction}>
            {t('common.remove')}
          </Button>

          <Button
            className={s['apply-btn']}
            onClick={handleApplyInstruction}
            isAccent={true}
            isRounded={true}
            disabled={isDisabled}
          >
            {t('common.apply')}
          </Button>
        </div>

        {isUpdatingInstruction || (isDeletingInstruction && <Loader />)}

        {showError && (
          <ErrorModal message={errorMessage} onClose={closeError} />
        )}
      </div>
    </Modal>
  );
};
